<div class="form-container">
  <h1 class="ion-text-center ion-margin-bottom">Sube tu factura</h1>

  <p class="ion-text-center">
    Si hay algún dato erróneo en la factura corrigelo,
    <b>
      la información ingresada debe corresponder con la factura para que sea
      válida.
    </b>
  </p>
  <h5 class="ion-text-center">Se subirá la siguiente información:</h5>
  <div class="ion-margin-top ion-padding-top">
    <app-form [questions]="billQuestions" [disabled]="isBillCorrect" (submit)="continue()"></app-form>

    <ion-grid>
      <ion-row *ngIf="!loading && isBillCorrect">
        <ion-col size="8" sizeMd="6" style="margin: auto">
          <ion-button
            expand="block"
            color="secondary"
            class="ion-text-wrap"
            (click)="correctBill()"
          >
            <ion-icon slot="start" name="pencil"></ion-icon> Corregir factura
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <ion-list *ngIf="bill?.products?.length">
    <ion-list-header>
      <ion-label>
        <h1>Productos</h1>
      </ion-label>
    </ion-list-header>

    <ion-item *ngFor="let product of products | slice : 0 : productsToShow">
      <ion-icon
        aria-hidden="true"
        name="checkmark-outline"
        slot="start"
        *ngIf="selectedContest?.validate_products && product.is_valid"
      ></ion-icon>
      <ion-label>
        <h4>{{ product.name }}</h4>
        <p>
          {{ product.quantity }} Und x
          {{ product.price | currency : "" : "symbol" : "1.0-0" }}
        </p>
      </ion-label>
      <ion-note slot="end">{{ product.code }}</ion-note>
    </ion-item>

    <ion-button
      expand="block"
      color="secondary"
      class="ion-text-wrap"
      *ngIf="products.length > 3"
      fill="clear"
      (click)="showMoreProducts()"
    >
      {{ products.length !== productsToShow ? "Ver todos" : "Ocultar" }}
    </ion-button>
  </ion-list>

  <ion-grid *ngIf="images">
    <ion-row>
      <ion-col *ngFor="let img of images; let i = index" class="bill-container">
        <div [style.background-image]="'url(' + img + ')'"></div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!--TODO Add bill products-->

  <ion-grid>
    <ion-row *ngIf="!loading">
      <ion-col size="12">
        <ion-item lines="none">
          <ion-checkbox
            labelPlacement="end"
            aria-labelledby="terms-lbl"
            [(ngModel)]="termsAccepted"
          ></ion-checkbox>
          <ion-label class="ion-padding-start ion-text-wrap" id="terms-lbl">
            Acepto los
            <a  (click)="openTermsAndConditions()" target="_blank"
              >Términos y Condiciones de la actividad.</a
            >
          </ion-label>
        </ion-item>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto">
        <ion-button
          expand="block"
          color="secondary"
          class="ion-text-wrap"
          (click)="changeBill()"
        >
          Tomar otra foto
        </ion-button>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto">
        <ion-button
          expand="block"
          class="ion-text-wrap"
          [disabled]="!termsAccepted"
          (click)="continue()"
        >
          Continuar
        </ion-button>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto">
        <ion-button
          expand="block"
          class="ion-text-wrap"
          fill="clear"
          (click)="goBack()"
        >
          Volver
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="loading">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

<!--
<app-custom-alert
  *ngIf="showCustomAlert"
  [notRecognizedFields]="notRecognizedFields"
  (close)="showCustomAlert = false"
  (back)="goBack()">
</app-custom-alert> -->

<ion-modal
  #alertModal
  [isOpen]="showCustomAlert"
  (didDismiss)="dismissAlertModal()"
  class="custom-alert-modal"
>

  <ng-template>

    <div class="custom-alert-container scrollable">

      <div class="custom-alert">

        <button class="close-btn" (click)="dismissAlertModal()">
          ✕
        </button>

        <div class="success-icon">
          <div class="circle-bg">
            <div class="circle">
              ✓
            </div>
          </div>
        </div>

        <h2>¡Tu factura se leyó bien!</h2>

        <p class="description">
          Solo falta que completes
          <strong>
            {{ fieldsCount }} campo{{ fieldsCount > 1 ? 's' : '' }}
          </strong>
          que no aparece{{ fieldsCount > 1 ? 'n' : '' }} claro{{ fieldsCount > 1 ? 's' : '' }} en la foto.
        </p>

        <ion-list class="fields-container">
          <ion-item
            *ngFor="let field of notRecognizedFieldsList"
            lines="none"
            class="field-item"
          >
            <ion-icon
              slot="start"
              name="pencil-outline" (click)="showCustomAlert = false">
            </ion-icon>

            <div>{{ field }}</div>
          </ion-item>
        </ion-list>

        <div class="info-box">
          <p>
            Al continuar verás el formulario: <strong>escribe o selecciona este dato
              y luego envía tu factura</strong>. También puedes corregir cualquier otro
            dato si algo no coincide.
          </p>
        </div>

        <div class="warning-box">
          <p>
            <strong>¿La foto no se ve bien?</strong>
            <span>
              También puedes volver a tomarla para que la lectura reconozca
              este dato por ti.
            </span>
          </p>
        </div>

        <button
          class="primary-btn"
          (click)="showCustomAlert = false"
        >
          Completar dato
        </button>

        <button
          class="secondary-btn"
          (click)="goBackFromModal()"
        >
          <ion-icon name="camera-outline"></ion-icon>
          Volver a tomar foto
        </button>

      </div>

    </div>

  </ng-template>
</ion-modal>
